export default __webpack_public_path__ + "static/media/11.4fede043.png";